const routers = [
    {
        path: '/search_result',
        name: 'search_result',
        meta: {
            exp: '搜索页面',
            requireAuth: false
        },
        component: () => import('@/views/search_result/index.vue')
        
    },
   
]
export default routers